<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<router-link to="/account/index" class="back-btn"><span></span>注销账号</router-link>
	</div>
	<div class="ld-panel-main">
		<el-form :label-width="formLabelWidth" v-if="mobile !== ''">
			<el-form-item label="手机号码">
				<el-input v-model="mobile" disabled />
			</el-form-item>
			<div class="code">
			  <el-form-item label="验证码">
			    <el-input v-model="code" autocomplete="off" />
			  </el-form-item>
			  <el-button type="primary" :disabled="codeSend" @click="codeChange">{{codeSendText}}</el-button>
			</div>
			<el-form-item>
				<el-button type="primary" @click="submitForm">提交</el-button>
			</el-form-item>
		</el-form>
		<el-result v-else icon="warning" title="请联系客服处理" />
	</div>
	<!-- 图形验证码 -->
	<el-dialog align-center v-model="captchaVisible" title="请输入图片中的验证码" width="280">
		<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style="margin-bottom: 10px;cursor: pointer;" />
	    <el-form class="captcha-form">
	      <el-form-item label="验证码">
	        <el-input v-model="captchaAnswer" autocomplete="off" />
	      </el-form-item>
	    </el-form>
	    <template #footer>
	      <div class="dialog-footer">
	        <el-button type="primary" @click="sendCodeClick">确定发送验证码</el-button>
	      </div>
	    </template>
	</el-dialog>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import Cookies from 'js-cookie';
	import { captchaFetch,checksecvarcode,sendsmscode } from '@/api/common';
	import sideNav from '../../components/sideNav.vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const pageTitle = 'account';
	const router = useRouter();
	const code = ref('');
	const codeSendText = ref('获取验证码');
	const codeSend = ref(false);
	const codeTime = ref(60);
	const captchaVisible = ref(false);
	const captchaAnswer = ref('');
	const captchaImg = ref('');
	const captchaId = ref('');
	const formLabelWidth = ref('160px');
	const mobile = Cookies.get('LDMOBILE');
	
	
	const captchaChange = () => {
		captchaFetch().then((res) => {
			if (res.code == 200) {
				captchaImg.value = res.data.captcha_data;
				captchaId.value = res.data.captcha_id;
			}
		})
	}
	const codeChange = () => {
		captchaChange()
		captchaVisible.value = !captchaVisible.value;
	}
	const sendCodeClick = () => {
		const param = {'captcha_answer':captchaAnswer.value,'captcha_id':captchaId.value,'way':'cancelaccount'}
		sendsmscode(param).then((res) => {
			if (res.code === 200) {
				codeSend.value = true;
				codeSendText.value = codeTime.value+'s后重新发送';
				let timer = setInterval(() => {
				   codeTime.value--;
				   codeSendText.value = codeTime.value + 's后重新发送';
				   if (codeTime.value < 0) {
					   clearInterval(timer);
					   codeSendText.value = '获取验证码';
					   codeTime.value = 60;
					   codeSend.value = false
				   }
				}, 1000)
				captchaVisible.value = !captchaVisible.value;
			}
		})
	}
	const submitForm = () => {
		const param = {'code':code.value,'way':'mobile'}
		checksecvarcode(param).then((res) => {
			if (res.code == 200) {
				router.push({ path: '/account/delMessage' })
			}
		})
	}
	
</script>

<style lang="scss" scoped>
	.code{
		overflow: hidden;
		.el-form-item{
			width: 42%;
			float: left;
			.el-input{width: 100%; margin-right: 20px;}
		}
	}
</style>